// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"716":"6c9515cb","1972":"6c9515cb","2284":"9ffca19a","2493":"6b6cfd7e","3664":"5e7a1e7a","3822":"8101457b","4133":"8101457b"}[chunkId] + ".chunk.css";
};